import { TPostingType } from "../types/rules";

type TPostingTypeDisplayMap = { [key in TPostingType]: string };
export const POSTING_TYPE_DISPLAY_MAP: TPostingTypeDisplayMap = {
  CREDIT: "Credit (Money In)",
  DEBIT: "Debit (Money Out)",
};
